import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { EntityIcon } from '@wedding/shared';
import EntityIconMark from './icons/EntityIconMark';

interface IdentifyButtonProps {
  guestName?: string | null;
  icon?: EntityIcon | null;
  homeHref: string;
  visitor?: boolean;
}

export default function IdentifyButton({ guestName, icon = null, homeHref, visitor = false }: IdentifyButtonProps) {
  const { t } = useTranslation();
  if (!guestName && !visitor) return null;

  const homeBase = homeHref.replace(/\/$/, '');
  const swapHref = guestName
    ? `${homeBase}/identify?change=1&return=${encodeURIComponent(window.location.href)}`
    : `${homeBase}/identify?return=${encodeURIComponent(window.location.href)}`;

  return (
    <Typography
      component="a"
      href={swapHref}
      sx={{
        position: 'fixed',
        top: { xs: 'calc(6px + 36px + 4px)', sm: 'calc(8px + 40px + 4px)' },
        right: { xs: 8, sm: 12 },
        zIndex: 1300,
        bgcolor: 'rgba(255,255,255,0.55)',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 1,
        borderRadius: 4,
        px: 1.5,
        py: 0.3,
        fontSize: { xs: '0.65rem', sm: '0.7rem' },
        fontWeight: 600,
        color: 'text.secondary',
        textDecoration: 'none',
        maxWidth: { xs: '46vw', sm: 280 },
        '&:hover': { bgcolor: 'rgba(255,255,255,0.8)', color: 'text.primary' },
      }}
    >
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'flex-start', gap: 0.5, whiteSpace: 'pre-line' }}>
        {guestName ? <EntityIconMark icon={icon} size={14} /> : null}
        <span>{guestName ? t('home.switchGuest', { name: guestName }) : t('visitor.identify')}</span>
      </Box>
    </Typography>
  );
}
